/*
 * Copyright (c) 2026. Orion Analytics. All Rights Reserved
 */

/*
 * Copyright (c) 2026. Orion Analytics. All Rights Reserved
 */

import { Link } from "react-router-dom";

export default function NewsCard({ item }) {

    return (

        <Link
            to={`/news/article/${item.id}`}
            className="
                group
                block
                bg-zinc-900
                border
                border-zinc-800
                rounded-2xl
                overflow-hidden
                hover:border-emerald-500
                transition-all
                duration-300
            "
        >

            <div className="
                h-1
                bg-gradient-to-r
                from-emerald-400
                via-cyan-400
                to-blue-500
            " />

            <div className="p-5">

                <div className="
                    flex
                    items-center
                    justify-between
                    mb-4
                ">

                    <span className="
                        text-xs
                        uppercase
                        tracking-wide
                        text-emerald-400
                        font-semibold
                    ">
                        MARKET NEWS
                    </span>

                    <span className="
                        text-xs
                        text-zinc-500
                    ">
                        {item.date}
                    </span>

                </div>

                <h3 className="
                    text-lg
                    font-semibold
                    text-white
                    leading-snug
                    mb-4
                    line-clamp-3
                    group-hover:text-emerald-400
                    transition-colors
                ">
                    {item.title}
                </h3>

                <p className="
                    text-sm
                    text-zinc-400
                    leading-relaxed
                    line-clamp-4
                ">
                    {item.description}
                </p>

            </div>

        </Link>
    );
}